import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'xml',
  version: '1.1.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'xmlToJson',
      options: [
        { value: 'xmlToJson', name: 'XML to JSON' },
        { value: 'jsonToXml', name: 'JSON to XML' },
      ],
      description: 'The XML operation to perform',
    },
    {
      key: 'xmlInput',
      label: 'XML',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Previous"].output.xmlString }}',
      description: 'The XML string to parse into a JSON object',
      displayOptions: {
        show: {
          operation: ['xmlToJson'],
        },
      },
    },
    {
      key: 'jsonInput',
      label: 'JSON Data',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Previous"].output.data }}',
      description: 'The JSON data to convert to XML',
      displayOptions: {
        show: {
          operation: ['jsonToXml'],
        },
      },
    },
    {
      key: 'rootElementName',
      label: 'Root Element Name',
      type: 'string',
      required: false,
      default: 'root',
      placeholder: 'e.g., root',
      description: 'The name of the root XML element',
      displayOptions: {
        show: {
          operation: ['jsonToXml'],
        },
      },
    },
    {
      key: 'pretty',
      label: 'Pretty Print',
      type: 'boolean',
      required: false,
      default: true,
      description: 'Format the XML output with indentation for readability',
      displayOptions: {
        show: {
          operation: ['jsonToXml'],
        },
      },
    },
  ],
};

export default schema;
